import {
	GoogleMapsInitializer,
	type GoogleMapsLibraries
} from '@/core/service/googleMaps/initializer';
import GmapMap from '@/core/service/googleMaps/components/GmapMap/GmapMap.vue';
import { GoogleMapsAPI } from '@/core/service/googleMaps/api';
import GmapMarker from '@/core/service/googleMaps/components/GmapMarker/GmapMarker.vue';
import GmapCluster from '@/core/service/googleMaps/components/GmapCluster/GmapCluster.vue';
import GmapQuadrilateral from '@/core/service/googleMaps/components/GmapQuadrilateral/GmapQuadrilateral.vue';

export default defineNuxtPlugin({
	name: 'google-maps-api',
	async setup(nuxtApp) {
		nuxtApp.vueApp.component('GmapMap', GmapMap);
		nuxtApp.vueApp.component('GmapMarker', GmapMarker);
		nuxtApp.vueApp.component('GmapCluster', GmapCluster);
		nuxtApp.vueApp.component('GmapQuadrilateral', GmapQuadrilateral);

		const runtimeConfig = useRuntimeConfig();

		const maps = new GoogleMapsInitializer({
			key: runtimeConfig.public.GOOGLE_MAPS_KEY,
			libraries: ['places', 'maps', 'marker'] as GoogleMapsLibraries[]
		});

		const googleMapsApi = new GoogleMapsAPI(maps);

		const api = await googleMapsApi.getLibraries();

		return {
			provide: {
				googleMapsApi: api
			}
		};
	}
});
